import { Parameter } from '.';

import { ITableParameterProps } from './types';

export class TableParameter extends Parameter<ITableParameterProps> {
  constructor(params: ITableParameterProps) {
    super(params);

    this.state.cssProps = params.cssProps ?? { TH: {} };
  }
}
